module.exports = __webpack_public_path__ + "img/customer_active.7ed79e0d.svg";